function getUserAgent() {
    return navigator.userAgent;
}

export { getUserAgent };
//# sourceMappingURL=index.js.map
